export default "__VITE_ASSET__cazoNNND__"